(function (angular) {
	'use strict';

	angular.module('futureEarningsChartModule', [
		'coreModule',
		'loaderModule',
		'momentModule'
	]);
})(window.angular);